import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { DialogActionService } from 'src/app/Services/dialog-actions.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { OrgModule } from '../../../../modules/organization';
declare const Swal;
import indiaStates from './../../../../../assets/js/india.state.list.json';

const driverIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="288" height="288" viewBox="0 0 350 350"><g transform="translate(0 3)" fill="#6462af" class="color000 svgShape"><path fill="#6462af" stroke="#6462af" stroke-linecap="round" stroke-linejoin="round" stroke-width="7.006" d="m 133.95793,188.24392 c -26.77563,0.0212 -86.338187,16.04421 -86.338187,43.34901 v 42.14252 c 0,4.8048 0.67733,9.46143 1.92615,13.86406 H 258.88268 c 1.24882,-4.40263 1.92615,-9.05926 1.92615,-13.86406 v -42.14252 c 0,-27.3048 -54.35559,-43.43368 -81.13123,-43.39134 z" class="color087cc4 svgShape colorStroke242424 svgStroke"/><path fill="#ffffff" stroke="#6462af" stroke-width="7.091" d="M201.09811 92.931125c-9.01694 0-16.31938 7.556445-16.31938 16.890875 0 9.33443 7.30244 16.91204 16.31938 16.91204 9.01693 0 16.34054-7.57761 16.34054-16.91204 0-9.33443-7.32361-16.890875-16.34054-16.890875zM107.4998 92.931125c-9.016937 0-16.340547 7.556445-16.340547 16.890875 0 9.33443 7.32361 16.91204 16.340547 16.91204 9.01693 0 16.34054-7.57761 16.34054-16.91204 0-9.33443-7.32361-16.890875-16.34054-16.890875z" class="colorfedbab svgShape colorStroke242424 svgStroke"/><path fill="#ffffff" stroke="#6462af" stroke-width="7.091" d="m 132.47628,112.31137 h 45.635 l 1.97511,75.41196 6.84795,1.41187 -30.50312,68.68172 -30.11822,-68.68172 7.515,-0.96806 z" class="colorffe8bd svgShape colorStroke242424 svgStroke"/><path fill="#ffffff" stroke="#6462af" stroke-width="7.091" d="m 111.3521,52.24909 c -2.98448,6.561619 -4.6778,13.906397 -4.6778,21.632175 v 49.317965 c 0,27.6858 21.42051,50.33396 47.53999,50.33396 v 0 c 26.16181,0 47.56115,-22.64816 47.56115,-50.33396 V 73.881265 c 0,-7.725778 -1.69333,-15.070556 -4.65664,-21.632175 z" class="colorffe8bd svgShape colorStroke242424 svgStroke"/><path fill="#6462af" stroke="#6462af" stroke-width="6.845" d="M 207.5188,68.400699 C 169.74618,87.934622 135.81085,71.398026 100.28272,69.833682 90.072238,51.258562 98.846821,39.397064 111.45036,29.207324 125.35674,17.982659 140.14057,12.224387 153.914,12.06517 c 15.52835,-0.159093 30.12616,7.191227 40.44289,15.496936 13.93305,11.251189 20.3145,26.827739 13.16191,40.838593 z" class="color087cc4 svgShape colorStroke242424 svgStroke"/><path fill="#ffffff" stroke="#6462af" stroke-width="6.845" d="m 205.91256,82.605753 0.40091,-12.340286 C 174.61861,61.322914 134.2908,61.26261 100.28272,69.833682 l 0.45402,13.206384" class="color1d9ff0 svgShape colorStroke242424 svgStroke"/><path fill="#ffffff" stroke="#6462af" stroke-width="6.845" d="m 205.04603,85.144814 c -3.69597,12.259536 -24.86132,20.167256 -51.69026,20.167256 -26.85563,0 -48.02098,-7.90772 -51.717,-20.167256 34.88568,-7.668868 67.16553,-7.775035 103.40726,0 z" class="color232323 svgShape colorStroke242424 svgStroke"/><path fill="#6462af" stroke="#6462af" stroke-linecap="round" stroke-linejoin="round" stroke-width="7" d="m 216.94602,192.83317 -56.38893,94.69009 27.2763,-0.0766 48.35613,-86.32808 c -2.69402,-2.2774 -9.95082,-6.28297 -19.2435,-8.28536 z" class="color242424 svgShape colorStroke242424 svgStroke"/><path fill="#6462af" stroke="#6462af" stroke-width="6.845" d="M210.11836 195.35455l-23.18402-6.21092-29.40122 85.1624 38.00702-46.32871-4.31642-8.05583 10.56038-4.95021zM103.12898 195.35455l23.18402-6.21092 25.92671 84.09332-34.53251-45.25963 4.31642-8.05583-10.56038-4.9502z" class="color087cc4 svgShape colorStroke242424 svgStroke"/><path fill="#ffffff" stroke="#6462af" stroke-width="7.091" d="m 135.73689,210.35528 c 6.45266,18.78418 12.90532,54.26238 19.35798,56.35255 9.78231,-7.77379 14.85284,-37.53584 22.27926,-56.30376 -6.66272,3.27612 -13.70771,4.96344 -20.81115,4.98441 -7.11066,-0.0342 -14.16092,-1.73814 -20.82609,-5.0332 z" class="colorfff svgShape colorStroke242424 svgStroke"/><path fill="#ffffff" fill-rule="evenodd" stroke="#6462af" stroke-width="7" d="m 154.19759,207.18074 c -42.70084,0 -77.332703,34.82253 -77.332703,77.82699 0,0.8687 0.01935,1.73305 0.04741,2.59484 H 145.9425 c -0.22305,-0.77014 -0.3453,-1.58408 -0.3453,-2.42806 0,-4.75606 3.85213,-8.61437 8.6004,-8.61437 4.78123,0 8.63274,3.85831 8.63274,8.61437 0,0.84398 -0.12149,1.65792 -0.34472,2.42806 h 69.03017 c 0.0281,-0.86179 0.0479,-1.72614 0.0479,-2.59484 0,-43.00446 -34.63229,-77.82699 -77.36615,-77.82699 z m 0,19.72285 c 28.82119,0 52.69513,21.18655 57.04495,48.95818 -42.89995,0 -43.03272,-15.16664 -57.04495,-15.16664 -14.01223,0 -14.14542,15.16664 -57.04554,15.16664 4.38319,-27.77163 28.25705,-48.95818 57.04554,-48.95818 z" class="color3f4751 svgShape colorStroke242424 svgStroke"/></g></svg>`;

export interface Subject {
  name: string;
  phone: number;
}

@Component({
  selector: 'app-createorg',
  templateUrl: './vieworg.component.html',
  styleUrls: ['./vieworg.component.css']
})

export class ViewOrgComponent {

  public organization: any = OrgModule;
  public editForm: boolean;
  public orgDetails = [];
  public enableOrgCards:boolean = false;

  orgID: any;
  userType: string;
  stateArr: any;
  isSearchShow: boolean;
  coutData = 4;
  // fillter ngModel
  orgName: any = '';
  city: any = '';
  status: any = '';
  // ---------

  collection = [];

  constructor(
    public api: ApiService,
    public dialogService: DialogActionService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public loderservice: LoaderService,
    iconRegistry: MatIconRegistry, sanitizer: DomSanitizer,
  ) {
    for (let i = 1; i <= 200; i++) {
      this.collection.push(`item ${i}`);
    }
    iconRegistry.addSvgIconLiteral('driverIcon', sanitizer.bypassSecurityTrustHtml(driverIcon));
    this.userType = this.storage.get('userType');
  }
  public cols = [
    { key: '#', display: '#' },
    { key: 'orgName', display: 'Organization Name' },
    { key: 'orgEmail', display: 'Email' },
    { key: 'city', display: 'City' },

    { key: 'primaryContactName', display: 'Primary Contact Person' },
    { key: 'primaryContactEmail', display: 'Contact Email' },
    { key: 'primaryContactNumber', display: 'Contact Number' },

    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'view', color: 'primary', icon: 'View' },
          { display: 'update', color: 'primary', icon: 'Edit', class:'fs-13' },
          { display: 'delete', color: 'warn', icon: 'Delete' }
        ]
      }
    }
  ];
  ngOnInit() {
    // console.log(this.loderservice.show())
    if (this.userType != 'maste-admin') {
      this.router.navigate(['/master/login']);
    }
    this.getOrgList();
    // console.log(this.submitted)

    const states = {};
    this.stateArr = indiaStates.IND;
    // console.log(this.stateArr)
  }

  fiterData() {
    this.enableOrgCards = false;
    const obj = {
      orgName: this.orgName,
      city: this.city,
      status: this.status
    };
    this.api.listOrg(obj).then((res: any) => {
      // console.log(res)
      if (res.status == 'success') {
      // this.swal.swalFunction(res.status, res.status, res.message, 2000);
      this.orgDetails = res.data;
      this.enableOrgCards = true;
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
        this.enableOrgCards = true;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  showSearch() {
    this.isSearchShow = true;
  }
  closeSearch(){
    this.isSearchShow = false;
    this.orgName = '';
    this.city = '';
    this.status = '';
    this.fiterData();
  }

  viewOrg(item) {
    // console.log(item)
    this.router.navigate(['/master/organization/single-view-org',item.orgID]);
  }
// getPage(e,p){
//   console.log(e,p)
// }


  getOrgList() {
    const obj = {
      page: 1,
      limit: 30
    };
    this.api.listOrg(obj)
      .then((res: any) => {
        if (res.status == 'success') {
          this.orgDetails = res.data;
          this.enableOrgCards = true;
        }
      })
      .catch((error: any) => {
        console.log('Error', error);
      });



  }

  viewOrgAction(action, item, event) {
    event.stopPropagation();
    if (action == 'delete') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor:  '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteOrganizationData(item);
          Swal.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          );
        }
      });
    } else if (action == 'edit') {

      this.router.navigate(['/master/organization/edit-org', item.orgID]);
    }


  }
  onActionHandler(e: any) {
    const data = e.data;
    if (e.action.display.toLowerCase() == 'update') {
      this.orgID = e.data.orgID;
      for (const f of this.organization) {
        // console.log(f)
        const name = f.name;
        let value = '';

        if (f.type == 'dropdown') {
          const val = data[name].split(',');
          const temp = [], str = [];
          val.map(item => { temp.push({ value: val, name: val }); str.push(item); });
          f.selected = temp;
          f.value = str.join(',');
        } else {
          value = name;
          f.value = data[value];

        }

      }
      console.log('organization', this.organization);

      this.editForm = true;
    } else if (e.action.display.toLowerCase() == 'delete') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor:  '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('delete click');
          this.deleteOrganizationData(e);
          Swal.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          );
        }
      });
    }
    if (e.action.display.toLowerCase() == 'view') {
      // this.storage.setData({orgSingleDate:e.data})
      console.log(e);
      this.router.navigate(['/master/organization/single-view-org', e.data.orgID]);
    }

  }




  deleteOrganizationData(e) {
    const obj = {
      orgID: e.orgID
    };
    this.api.deleteOrg(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.staus, res.staus, res.message, 2000);
        this.getOrgList();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction(res.staus, res.staus, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  submitted(e: any) {
    console.log(e);
  }
  formSubmit(e: any) {
    if (e == 0) { this.editForm = false; } else {
      console.log(e);
    }
    console.log('----------', e);
  }
}
